// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SimulationSoftwareType } from "./SimulationSoftwareType";
import {
  SimulationSoftwareTypeFromJSON,
  SimulationSoftwareTypeFromJSONTyped,
  SimulationSoftwareTypeToJSON,
  SimulationSoftwareTypeToJSONTyped,
} from "./SimulationSoftwareType";

/**
 *
 * @export
 * @interface SimulationSoftware
 */
export interface SimulationSoftware {
  /**
   *
   */
  id: SimulationSoftwareType;
  /**
   *
   */
  version?: string | null;
}

/**
 * Check if a given object implements the SimulationSoftware interface.
 */
export function instanceOfSimulationSoftware(value: object): value is SimulationSoftware {
  if (!("id" in value) || value["id"] === undefined) return false;
  return true;
}

export function SimulationSoftwareFromJSON(json: any): SimulationSoftware {
  return SimulationSoftwareFromJSONTyped(json, false);
}

export function SimulationSoftwareFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationSoftware {
  if (json == null) {
    return json;
  }
  return {
    id: SimulationSoftwareTypeFromJSON(json["id"]),
    version:
      json["version"] === undefined ? undefined : json["version"] === null ? null : json["version"],
  };
}

export function SimulationSoftwareToJSON(json: any): SimulationSoftware {
  return SimulationSoftwareToJSONTyped(json, false);
}

export function SimulationSoftwareToJSONTyped(
  value?: SimulationSoftware | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    id: SimulationSoftwareTypeToJSON(value["id"]),
    version: value["version"],
  };
}
